import { Logo } from "@/components/navigation/logo";
import { MainNavigation } from "@/components/navigation/main-navigation";
import { SearchBar, SearchButton } from "@/components/navigation/search-bar";
import { UserMenu } from "@/components/navigation/user-menu";
import { ThemeToggle } from "@/components/navigation/theme-toggle";
import { MobileMenu } from "@/components/navigation/mobile-menu";
import { Button } from "@/components/ui/button";
import Link from "next/link";

export function Header() {

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background">
      <div className="container max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          {/* Left: Mobile Menu + Logo */}
          <div className="flex items-center gap-4 min-w-0">
            <div className="lg:hidden flex-shrink-0">
              <MobileMenu />
            </div>
            <div className="flex-shrink-0">
              <Logo />
            </div>
          </div>

          {/* Center: Search Bar */}
          <div className="hidden md:flex items-center flex-1 max-w-2xl">
            <SearchBar />
          </div>

          {/* Right: Submit Button + Theme + User */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <SearchButton />
            <Button
              size="sm"
              className="hidden sm:flex bg-primary hover:bg-primary-hover text-primary-foreground rounded-full px-4">
                <Link href="/submit">
                    Разместить продукт
                </Link>
            </Button>
            <ThemeToggle />
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
}
